export const shallowEqual = <T extends object>(fObj: T, sObj: T) => {
    return Object.keys(fObj).length === Object.keys(fObj).length &&
        (Object.keys(fObj) as (keyof typeof fObj)[]).every((key) => {
            return (
                Object.prototype.hasOwnProperty.call(sObj, key) && fObj[key] === sObj[key]
            );
        });
}
